import { TFunction } from "i18next"
import { formatInServerTimeZone } from "@/lib/initial-time-zone"
import { EMPTY_VALUE_PLACEHOLDER } from "@/modules/admin/better-doc/constants/better-doc-constants"

const DATE_TIME_FORMAT = "dd.MM.yyyy HH:mm:ss"

export const formatBetterDocDateTime = (dateTime: string | null) =>
  dateTime === null ? EMPTY_VALUE_PLACEHOLDER : formatInServerTimeZone(dateTime, DATE_TIME_FORMAT)

const DATE_FORMAT = "dd.MM.yyyy"

export const formatBetterDocDate = (dateTime: string | null) =>
  dateTime === null ? EMPTY_VALUE_PLACEHOLDER : formatInServerTimeZone(dateTime, DATE_FORMAT)

export const isBetterDocTextPresent = (value: string | null | undefined): value is string =>
  value !== null && value !== undefined && value !== ""

export const formatBetterDocValue = (value: string | number | null) =>
  value === null || value === "" ? EMPTY_VALUE_PLACEHOLDER : value

export const formatBetterDocBoolean = (t: TFunction, value: boolean | null) => {
  if (value === null) {
    return EMPTY_VALUE_PLACEHOLDER
  }

  return value ? t("common.yes") : t("common.no")
}
